export const ORDER_STATUSES = [
  'pending',
  'approved',
  'scheduled',
  'completed',
  'cancelled',
];
export type OrderStatus =
  | 'pending'
  | 'approved'
  | 'scheduled'
  | 'completed'
  | 'cancelled';
